export default __webpack_public_path__ + "static/media/debian.1c04beb5.svg";